import useAppMain from "src/hooks/useAppMain";
import { CLIENT_TAB_LIST, formatter } from "src/utils/constants";
import {
  Text,
  Box,
  Flex,
  useMantineTheme,
  Skeleton,
  Button,
  Divider,
} from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";
import { useGetSignedAgreementCheckoutQuery } from "src/generated/graphql";
import { useState } from "react";
import { useAppContext } from "src/api/AppContext";
import PaymentSelection, {
  ISelectedPayment,
} from "src/components/PaymentSelection";
import { UnsavedMethod } from "src/api/context/CatalogContext";

function AgreementCheckout() {
  useAppMain(CLIENT_TAB_LIST.AGREEMENT_CHECKOUT, true);
  const { currentClient } = useAppContext();
  const theme = useMantineTheme();
  const primaryTextColor = theme.colors.primaryTextColor[6];
  const secondaryTextColor = theme.colors.secondaryTextColor[6];
  const cardBg = theme.colors.primary[4];
  const navigate = useNavigate();
  const { signedAgreementId = "" } = useParams();
  const [selectedPayment, setselectedPayment] =
    useState<ISelectedPayment>(null);

  const { loading, data: signedAgreementDetail } =
    useGetSignedAgreementCheckoutQuery({
      variables: {
        id: signedAgreementId,
      },
      skip: !signedAgreementId,
    });
  const { agreement } = signedAgreementDetail?.signedAgreementOne || {};

  const handleConfirm = () => {
    navigate(-3);
  };

  const reccurringCost =
    agreement?.recurringCharges?.reduce((acc, e) => acc + (e?.cost || 0), 0) ??
    0;
  const initialCost =
    agreement?.initialCharges?.reduce((acc, e) => acc + (e?.cost || 0), 0) ?? 0;
  const totalCost = reccurringCost + initialCost;

  if (loading) return <Skeleton w="100%" height={80} />;
  return (
    <Flex
      direction={"column"}
      justify={"space-between"}
      sx={{ height: "100%" }}
    >
      <Box>
        <Flex bg={cardBg} p={12} gap={10} sx={{ borderRadius: 8 }}>
          <Box
            bg={"#B1B1B1"}
            sx={{ height: 40, width: 40, borderRadius: 4 }}
            mt={5}
          ></Box>
          <Box sx={{ flex: 1 }}>
            <Text size={18} color={primaryTextColor}>
              {agreement?.name}
            </Text>
            <Flex justify={"space-between"}>
              <Text size={12} color={primaryTextColor}>
                Monthly Subscription
              </Text>
              <Text size={12} color={primaryTextColor}>
                {formatter.format(reccurringCost)}
              </Text>
            </Flex>
            <Flex justify={"space-between"}>
              <Text size={12} color={primaryTextColor}>
                Sign-up Fee
              </Text>
              <Text size={12} color={primaryTextColor}>
                {formatter.format(initialCost)}
              </Text>
            </Flex>
          </Box>
        </Flex>

        <Box mt={"sm"}>
          <Text fw={500} size={18} color={secondaryTextColor}>
            Payment
          </Text>
          <Box mt={"xs"} bg={cardBg} sx={{ borderRadius: 8, width: "100%" }}>
            <Flex justify={"space-between"} p={12}>
              <Text size={18} fw={500} color={primaryTextColor}>
                Today’s Charges
              </Text>

              <Text size={16} fw={600} color={primaryTextColor}>
                {formatter.format(totalCost)}
              </Text>
            </Flex>
            <Divider pt={5} />
            <Box p={12}>
              <PaymentSelection
                clientId={currentClient?.id}
                selectedPayment={selectedPayment}
                setselectedPayment={setselectedPayment}
                getPrimaryPayment={true}
                permittedMethods={[UnsavedMethod.Card, UnsavedMethod.ACH]}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box>
        <Text size={10} color={secondaryTextColor}>
          All sales are final. Refunds are not guaranteed and, if applicable,
          will be resolved on a case-by-case basis. In the case of
          subscriptions, the itemized totals shown above represent only the
          initial charges due at sign-up and are not reflective of the total
          recurring payments due over the term duration.
        </Text>
        <Button fullWidth onClick={handleConfirm} mt={3}>
          Confirm Agreement Purchase
        </Button>
      </Box>
    </Flex>
  );
}

export default AgreementCheckout;
